import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import ListenerMessage from "../../listen/ListenerMessage";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class NewWebRtcCall extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "newWebRtcCall";
    }

    onAction(payload: CometOperatorApplication.NewWebRtcCallCometMessageOpenApiModel, message: ListenerMessage): void {
        let call = AbstractWebRtcCall.create(payload.call!.id)!;
        if (call.isCallForThisInstance()) {
            if (call.isWebRtcSupported()) {
                call.setCallData(payload.call!);
                AbstractWebRtcCall.setIncomingCalls([
                    ...AbstractWebRtcCall.incomingCalls.value,
                    call
                ]);
                call.onNewIncomingCall();
            } else {
                call.showWebRtcNotSupportedError();
            }
        }
    }

}